import React from 'react';

import PropTypes from 'prop-types';

import { FormFieldWrapper, FormTooltipIcon,Input, TextArea } from 'components';

export const FormField = ({
  label,
  input,
  meta = {},
  showValid,
  readOnly,
  sideLabel,
  isTextArea,
  computeDisplayError,
  tooltip,
  after,                 // 👈 NEW: slot for trailing controls (buttons, etc.)
  afterWidth = 120,      // 👈 NEW: how much padding to reserve inside the field
  afterRight = 8,        // 👈 NEW: distance from field's right edge
  ...rest
}) => {
  const shouldDisplayError = computeDisplayError
    ? computeDisplayError(meta)
    : !!((meta.error || meta.submitError) && meta.touched);

  const labelWithTooltip = (
    <>
      {label}
      {tooltip && <FormTooltipIcon message={tooltip} />}
    </>
  );

  // Checkboxes/radios must not be stretched to full width or get the `after` padding.
  const isCheckboxOrRadio = input?.type === 'checkbox' || input?.type === 'radio';

  // If a `style` prop was passed, preserve it and only add paddingRight when `after` exists.
  const baseStyle = rest?.style || {};
  const inputStyle =
    after
      ? { ...baseStyle, paddingRight: Math.max(afterWidth, baseStyle.paddingRight || 0) }
      : baseStyle;

  return (
    <FormFieldWrapper
      invalid={shouldDisplayError}
      label={labelWithTooltip}
      error={meta.error || meta.submitError}
    >
      <div style={{ position: 'relative', display: 'flex', alignItems: isTextArea ? 'stretch' : 'center' }}>
        <div style={{ flex: isCheckboxOrRadio ? 'none' : 1 }}>
          {isTextArea ? (
            <TextArea
              {...input}
              readOnly={readOnly}
              {...rest}
              style={{ ...inputStyle, width: '100%' }}
            />
          ) : (
            <Input
              {...input}
              {...rest}
              sideLabel={sideLabel}
              readOnly={readOnly}
              valid={showValid ? meta.valid && !meta.validating : false}
              invalid={shouldDisplayError}
              style={isCheckboxOrRadio ? inputStyle : { ...inputStyle, width: '100%' }}
            />
          )}
        </div>


        {after ? (
          <div
            style={{
              position: 'absolute',
              right: afterRight,
              top: isTextArea ? 8 : '50%',
              transform: isTextArea ? 'none' : 'translateY(-50%)',
              display: 'flex',
              gap: 8,
              // prevent the after content from blocking clicks inside the input’s text area
              pointerEvents: 'auto',
            }}
          >
            {after}
          </div>
        ) : null}
      </div>
    </FormFieldWrapper>
  );
};

FormField.propTypes = {
  label: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  showValid: PropTypes.bool,
  readOnly: PropTypes.bool,
  isTextArea: PropTypes.bool,
  tooltip: PropTypes.string,
  after: PropTypes.node,          // 👈 NEW
  afterWidth: PropTypes.number,   // 👈 NEW
  afterRight: PropTypes.number,   // 👈 NEW
};

export default FormField;